<template>
  <div>
    <div
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font" style="margin-bottom: 10px">
          <img
            src="../../static/images/chaxun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            活动统计
          </span>
        </p>

        <div v-if="showPage">
          <table class="table table-striped table-hover" ref="print">
            <thead>
              <tr style="white-space: nowrap">
                <th>活动名称</th>
                <th>开始时间</th>
                <th>结束时间</th>
                <th>活动品数</th>
                <th>活动下单数</th>
                <th>活动期间销售额</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index">
                <td>{{ item.hdlx }}</td>
                <td>{{ item.stime.replace("T", " ") }}</td>
                <td>{{ item.etime.replace("T", " ") }}</td>
                <td>{{ item.goodscounts }}</td>
                <td>{{ item.ordernums }}</td>
                <td>{{ item.amount }}</td>
                <td>
                  <el-button
                    @click="goClick(item)"
                    type="primary"
                    size="mini"
                    plain
                    >查看活动品种</el-button
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else>
          <img
            src="../../static/images/wushuju.jpg"
            style="width: 300px; height: 300px; display: block; margin: 0 auto"
            alt=""
          />
        </div>
      </div>
    </div>

    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
  </div>
</template>
<script>
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";

export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0, //搜索返回的清单
      isLoading: false,
      showPage: true,
      tableData: [],
    };
  },
  components: {
    vPagination,
    Loading,
  },
  computed: {},

  methods: {
    getClerkGoodsForward: async function () {
      const that = this;
      that.isLoading = true;
      const { data: res } = await this.$http.post("DsApi/GetHdPage", {});
      that.isLoading = false;
      if (res.isok) {
        that.tableData = res.list;
      }
    },
    goClick(item) {
      this.$router.push({
        path: 'hdpz',
        query: {
          hdid: item.hdid,
        },
      });
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.getClerkGoodsForward();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.table {
  margin-bottom: 0;
}
.hei {
  height: 1.5rem;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.money {
  color: red;
  font-weight: 500;
}
.span_close:hover {
  color: #3190e8;
}
.totalNum {
  color: green;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/hdtj.vue